// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"1a68530d","268":"51517be6","294":"33acec23","355":"bb7bb6b2","375":"86e84879","457":"850f3002","484":"14cb0921","551":"c2ddb01f","679":"5badd54c","842":"01821987","851":"3f0086ba","852":"09ee4510"}[chunkId] + ".chunk.js";
};